import { eventChannel } from 'redux-saga'

export const createChannel = fn => eventChannel(fn)
